module.exports = __webpack_public_path__ + "img/event_point_roulette.12876359.png";